<script setup lang="ts">
import {
  useForm, useValidateForm, Form as vForm,
} from 'vee-validate';
import useNotificationStore from '@/stores/flash-messages';

const { errors } = useForm();
const notificationStore = useNotificationStore();

const emit = defineEmits(['valid-submission', 'invalid-submission']);
const validate = useValidateForm();

interface Props {
  errorMessage?: string;
  validationSchema?: any;
}

const props = withDefaults(defineProps<Props>(), {
  errorMessage: 'The form is missing mandatory fields',
  validationSchema: null,
});

const onSubmit = async () => {
  const values = await validate();
  const errorKeys = Object.keys(values.errors);
  if (errorKeys.length > 0) {
    notificationStore.pushNotification({
      id: 'FORM_ERRORS',
      message: props.errorMessage,
      type: 'error',
    });
    emit('invalid-submission');
    const errorElements = errorKeys.map((i) => {
      if (document.getElementById(i)) {
        return document.getElementById(i);
      }
      return document.getElementById(`${i}-true`);
    }).sort((a, b) => {
      if (a === b) return 0;
      if (!a || !b) return 0;
      if (a.compareDocumentPosition(b) > b.compareDocumentPosition(a)) {
        return -1;
      }
      return 1;
    });
    const input: HTMLElement | null = errorElements[0];
    if (typeof input?.focus !== 'undefined') {
      input.scrollIntoView({ block: 'center' });
      input.focus();
    }
  } else {
    emit('valid-submission');
  }
};

</script>

<template>
  <v-form
    v-slot="{ handleSubmit }"
    ref="form"
    as="div"
    autocomplete="off"
    :validation-schema="validationSchema"
    novalidate
  >
    <form
      autocomplete="off"
      novalidate
      @submit="handleSubmit($event, onSubmit)"
    >
      <slot :errors="errors"></slot>
    </form>
  </v-form>
</template>
